export default __webpack_public_path__ + "static/media/org-dashboard-logo.2814c9ab.png";